import { gql } from '@apollo/client'

const UPDATE_ATTACHMENT = gql`
  mutation UpdateAttachment($filename: String!, $id: Int!) {
    updateAttachment(id: $id, filename: $filename) {
      id
      createdAt
      filename
      format
      secureUrl
      publicId
      resourceType
    }
  }
`

export default UPDATE_ATTACHMENT
